"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitButtonWrapper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const material_1 = require("@mui/material");
const react_1 = require("react");
const fontawesome_icon_1 = require("./fontawesome-icon");
const DisabledTooltip = (0, material_1.styled)(({ className, ...props }) => ((0, jsx_runtime_1.jsx)(material_1.Tooltip, { ...props, classes: { popper: className } })))(({ theme }) => ({
    [`& .${material_1.tooltipClasses.tooltip}`]: {
        width: 260,
        backgroundColor: theme.palette.common.white,
        padding: theme.spacing(2),
        color: theme.palette.orange[80],
        boxShadow: theme.boxShadows.md,
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: theme.palette.gray[20],
    },
}));
exports.SubmitButtonWrapper = (0, react_1.forwardRef)(({ children, useTooltip, helperText, ...props }, ref) => {
    if (useTooltip && helperText) {
        return ((0, jsx_runtime_1.jsx)(DisabledTooltip, { placement: "top", title: (0, jsx_runtime_1.jsxs)(material_1.Box, { display: "flex", alignItems: "center", children: [(0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                            width: 34,
                            height: 34,
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: ({ palette }) => palette.orange[20],
                            color: ({ palette }) => palette.orange[60],
                            mr: "12px",
                            "& svg": {
                                fontSize: 16,
                            },
                        }, children: (0, jsx_runtime_1.jsx)(fontawesome_icon_1.FontAwesomeIcon, { sx: {}, icon: free_solid_svg_icons_1.faWarning }) }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "smallTextLabels", fontWeight: 500, flex: 1, children: helperText })] }), children: (0, jsx_runtime_1.jsx)(material_1.Box, { ref: ref, ...props, children: children }) }));
    }
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, { ref: ref, ...props, children: [children, (0, jsx_runtime_1.jsx)(material_1.Collapse, { in: Boolean(helperText), children: (0, jsx_runtime_1.jsxs)(material_1.Box, { display: "flex", alignItems: "center", mt: 1, children: [(0, jsx_runtime_1.jsx)(fontawesome_icon_1.FontAwesomeIcon, { sx: ({ palette }) => ({
                                mr: 1,
                                color: palette.orange[50],
                            }), icon: free_solid_svg_icons_1.faCircleExclamation }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "microText", sx: {
                                color: ({ palette }) => palette.orange[80],
                                fontWeight: 500,
                            }, children: helperText })] }) })] }));
});
